<template>
  <div id="sdk">
    <Menu></Menu>
    <!-- 轮播图 -->
    <div class="solo_bnr">
      <img
        class="pic"
        src="https://todeskcdnspeed.todesk.com/202307071816205ffe2ec9b2b490.png"
        alt=""
      />
      <div class="info">
        <h1 class="main_title">
          <span class="t1">ToDesk</span>
          <span class="t2">现已支持月付</span>
        </h1>
        <p class="desc">
          自研ZeroSync引擎&nbsp;&nbsp;·&nbsp;&nbsp;2K30帧超清画质
        </p>
        <a
          :href="`${_uc_mb_hostName}/orderManage/buyOrder?spuId=2&orderType=0&channel=gw`"
          class="link"
          >了解详情</a
        >
      </div>
    </div>
    <div class="nversion">
      <div class="left">
        <h2 class="title">
          <span class="end_title">NEW</span>
          <span class="main_title">ToDesk</span>
        </h2>
        <h2 class="title2">全新升级专业版</h2>
        <div class="nvvideo_bx">
          <video
            class="nvvideo"
            preload="auto"
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            poster="@/assets/solo/video11.png"
            webkit-playsinline="true"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202209061012225e7f8ba0bdc480.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
        </div>
        <div class="desc_item">
          <img class="desc_item_icon" src="@/assets/solo/check.png" alt="" />
          <div class="desc_info">
            <p class="desc_name">画质升级</p>
            <p class="desc_cont">2K超清画质，30帧丝滑流畅，尊享“本地般”体验</p>
          </div>
        </div>
        <div class="desc_item">
          <img class="desc_item_icon" src="@/assets/solo/check.png" alt="" />
          <div class="desc_info">
            <p class="desc_name">体验升级</p>
            <p class="desc_cont">享受7天免费试用，抢先体验VIP服务</p>
          </div>
        </div>
        <div class="desc_item">
          <img class="desc_item_icon" src="@/assets/solo/check.png" alt="" />
          <div class="desc_info">
            <p class="desc_name">支付升级</p>
            <p class="desc_cont">按月/年多种方式灵活支付，选择更舒心</p>
          </div>
        </div>
      </div>
      <img class="nv_bgi_left" src="@/assets/solo/nv_bgi_left.png" alt="" />
      <img class="nv_bgi_right" src="@/assets/solo/nv_bgi_right.png" alt="" />
    </div>
    <!-- video -->
    <div class="video">
      <ul>
        <li id="arr0">
          <img src="@/assets/solo/icon0.png" alt="" />
          <h3>手机、PAD等移动设备,</h3>
          <h3>支持<span>蓝牙外设</span></h3>
          <p>
            打破设备局限，速度更快，画质更清晰，操作更便捷，移动端也能畅享精准操作的快乐
          </p>
          <video
            class="video-css"
            id="video-0"
            preload="auto"
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            poster="@/assets/solo/video11.png"
            webkit-playsinline="true"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202208081155305e5b2c978694f4.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
        </li>
        <li id="arr1">
          <img src="@/assets/solo/icon1.png" alt="" />
          <h3>跨平台快速直连</h3>
          <h3><span>随时随地</span>都能远程控制</h3>
          <p>
            支持跨平台的远程控制，有且不限于PC对PC，iOS/Android也可以直接控制
          </p>
          <video
            class="video-css"
            id="video-1"
            preload="auto"
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            poster="@/assets/solo/video11.png"
            webkit-playsinline="true"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202302212117085f53598c4f5288.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
        </li>
        <li id="arr2">
          <img src="@/assets/solo/icon2.png" alt="" />
          <h3>PC端文件传输</h3>
          <h3><span>免费高速</span>不卡顿</h3>
          <p>使用文件管理器互相传输文件或直接拖拽传输，传输速度可高达12m/s</p>
          <video
            class="video-css"
            id="video-2"
            preload="auto"
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            webkit-playsinline="true"
            poster="@/assets/solo/video22.png"
            style="object-fit: fill"
            autoplay
            muted
            loop
            src="https://todeskcdnspeed.todesk.com/202206171430365e19ee46233470.mp4"
          ></video>
        </li>
        <li id="arr3">
          <img src="@/assets/solo/icon3.png" alt="" />
          <h3><span>大容量</span>设备列表</h3>
          <h3>灵活管理</h3>
          <p>如同通讯录一般管理设备，可以无限添加设备至设备列表中</p>
          <video
            class="video-css"
            id="video-3"
            preload="auto"
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            webkit-playsinline="true"
            poster="@/assets/solo/video33.png"
            style="object-fit: fill"
            autoplay
            muted
            loop
            src="https://todeskcdnspeed.todesk.com/202302212116315f53596915ca8c.mp4"
          ></video>
        </li>
        <li id="arr4">
          <img src="@/assets/solo/icon4.png" alt="" />
          <h3>多台设备</h3>
          <h3><span>轻松同步</span>连接</h3>
          <p>即便只有单台设备也可以同时控制多台设备，不再为设备多而犯愁</p>
          <video
            class="video-css"
            id="video-4"
            preload="auto"
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            webkit-playsinline="true"
            poster="@/assets/solo/video44.png"
            style="object-fit: fill"
            autoplay
            muted
            loop
            src="https://todeskcdnspeed.todesk.com/202206171428065e19edb6f4fccc.mp4"
          ></video>
        </li>
      </ul>
    </div>
    <div class="tab_card">
      <ul>
        <li>
          <img src="@/assets/solo/icon_1.png" alt="" />
          <p>全平台支持</p>
          <span>各平台相互连接不受限</span>
        </li>
        <li>
          <img src="@/assets/solo/icon_2.png" alt="" />
          <p>免费高清不限速</p>
          <span>全球部署高速服务器节点</span>
        </li>
        <li>
          <img src="@/assets/solo/icon_3.png" alt="" />
          <p>安全保障</p>
          <span>高强度端到端加密</span>
        </li>
        <li>
          <img src="@/assets/solo/icon_4.png" alt="" />
          <p>传输稳定</p>
          <span>自研算法，延时低至20ms</span>
        </li>
      </ul>
    </div>
    <!-- 下载按钮 -->
    <div class="download_btn" :class="{ pcss: type !== 'ios' }">
      <h2>ToDesk {{ type === "ios" ? "iOS&iPad" : "Android" }}版</h2>
      <p>立即免费下载，轻松远程操控</p>
      <a
        v-if="type === 'ios'"
        type="button"
        href="https://apps.apple.com/cn/app/todesk/id1519407428"
        ><img src="@/assets/solo/iosDownload.svg"
      /></a>
      <a v-else type="button" :href="href"
        ><img src="@/assets/solo/androidDownload.svg" alt=""
      /></a>
    </div>
    <!-- 个人介绍 -->
    <div class="introduce" :class="active == true ? 'open' : ''">
      <div class="introduce_mask"></div>
      <div class="item" v-for="(item, index) in comment_list" :key="index">
        <div class="item-content">
          <img :src="item.pic" alt="" />
          <div class="">
            <p>{{ item.name }}</p>
            <img
              v-for="i in item.stars"
              :key="'stars' + i"
              src="@/assets/solo/stars.png"
              alt=""
            />
            <img
              v-for="j in item.stars1"
              :key="'stars1' + j"
              src="@/assets/solo/stars_1.png"
              alt=""
            />
            <img
              v-for="k in item.stars0"
              :key="'stars0' + k"
              src="@/assets/solo/stars_0.png"
              alt=""
            />
          </div>
        </div>
        <p>{{ item.cont }}</p>
      </div>
      <button type="button" @click="open_mask()">
        <img
          :src="
            active == true
              ? require('@/assets/solo/icon_up.png')
              : require('@/assets/solo/icon_down.png')
          "
          alt=""
        />{{ active == true ? "收起" : "展示" }}
      </button>
    </div>
    <!-- 友情链接 -->
    <div class="seo_link">
      <h2>友情链接<span class="link-sp">(远程控制软件相关行业优先)</span></h2>
      <ul>
        <li v-for="(item, index) in rlinks" :key="index">
          <a :href="item.href" rel="nofollow">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Swiper, { Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import { getSystem, dealConfig } from "@/utils/util";
export default {
  components: {
    Menu,
    Footer,
  },
  data() {
    return {
      currentIndex: 0,
      cliHeight: 0,
      v: null,
      DOMobj: "",
      a: 0,
      tabsSwiper: null,
      active: false,
      type: getSystem(),
      href: null,
      rlinks: [
        { name: "久伴博客", href: "https://jiubx.com/8344.html" },
        { name: "阿酷杂货铺", href: "https://www.coolexe.com/109.html" },
        { name: "走客", href: "https://www.5v13.com/windows/25703.html" },
        { name: "酷微米", href: "https://www.kuweimi.com/see/todesk.html" },
        {
          name: "中关村在线",
          href: "https://xiazai.zol.com.cn/detail/49/489729.shtml",
        },
        { name: "better365", href: "https://www.better365.cn/" },
        { name: "异次元", href: "https://www.iplaysoft.com/todesk.html" },
        { name: "数码荔枝", href: "https://www.lizhi.io/product/todesk" },
        { name: "果核剥壳", href: "https://www.ghxi.com/todesk.html" },
        {
          name: "系统总裁",
          href: "https://www.sysceo.com/Software-softwarei-id-272.html",
        },
        { name: "MacWk", href: "https://www.macwk.com/soft/todesk" },
      ],
      comment_list: [
        {
          pic: require("@/assets/comment/icon_user1.png"),
          name: "袁小白",
          stars: 4,
          stars0: 0,
          stars1: 0,
          cont: "我能用ToDesk免费版稳定远程打星际2，稳定性，以及操作延迟上基本秒杀同类软件，快得不行，别的远程软件我目前没有找到能做到的。",
        },
        {
          pic: require("@/assets/comment/icon_user5.png"),
          name: "老青年",
          stars: 4,
          stars0: 0,
          stars1: 1,
          cont: "刚开始是其他远控不能用了，通过搜索，在豆瓣看到介绍，看介绍还不错的样子，就去下载使用了，才用2次，发现连接速度贼快，耐心等待下一次的更新。",
        },
        {
          pic: require("@/assets/comment/icon_user9.png"),
          name: "Crystal",
          stars: 4,
          stars0: 0,
          stars1: 1,
          cont: "我喜欢td的不限速，远程控制软件，需要有大量的服务器，需要大量的费用，现在对个人还是免费的真的很难得，手机app没有一堆广告，很难不支持！",
        },
        {
          pic: require("@/assets/comment/icon_user13.png"),
          name: "立秋的夏天",
          stars: 3,
          stars0: 2,
          stars1: 0,
          cont: "又免费又好用，非常快，良心工具了属于是，比其他友商好用多了就是说。",
        },
        {
          pic: require("@/assets/comment/icon_user17.png"),
          name: "蓝色透明",
          stars: 4,
          stars0: 1,
          stars1: 0,
          cont: "功能强大，速度流畅，连接稳定，细节再优化一下可以说是国产精品也不为过。",
        },
        {
          pic: require("@/assets/comment/icon_user2.png"),
          name: "稳如泰山",
          stars: 4,
          stars0: 1,
          stars1: 0,
          cont: "免费个人版不限速！不限速！不限速！ 重要说三遍，这个太关键了，核心体验保障！",
        },
        {
          pic: require("@/assets/comment/icon_user6.png"),
          name: "雨天风筝",
          stars: 3,
          stars0: 2,
          stars1: 0,
          cont: "一直在用，土啬裂推荐，很好用，很稳定，工作的时候帮了大忙。",
        },
        {
          pic: require("@/assets/comment/icon_user10.png"),
          name: "e修哥",
          stars: 3,
          stars0: 2,
          stars1: 0,
          cont: "界面很干净，没有一大堆乱七八糟的开屏广告真的是感恩，手机控电脑快的不行，国产软件赶紧支棱起来啊！",
        },
        {
          pic: require("@/assets/comment/icon_user14.png"),
          name: "诺诺",
          stars: 3,
          stars0: 2,
          stars1: 0,
          cont: "线路稳定不会卡死，没有广告还很稳定，良心企业，收费也可以接受，老用户赶紧来支持一波~",
        },
        {
          pic: require("@/assets/comment/icon_user18.png"),
          name: "启明星",
          stars: 4,
          stars0: 0,
          stars1: 1,
          cont: "延迟低还和在本机上操作没有差别，经常笔记本远程台式机躺在床上玩，速度一流。",
        },
        {
          pic: require("@/assets/comment/icon_user3.png"),
          name: "Zfh啦",
          stars: 3,
          stars0: 1,
          stars1: 1,
          cont: "没有同类软件其他多余的动画，指哪打哪，只能说又快有准确。",
        },
        {
          pic: require("@/assets/comment/icon_user7.png"),
          name: "夜神月",
          stars: 4,
          stars0: 1,
          stars1: 0,
          cont: "确定这个收费模式不会亏钱吗，速度也太快了，游戏也能带的动就很离谱啊。",
        },
        {
          pic: require("@/assets/comment/icon_user11.png"),
          name: "海事如风",
          stars: 3,
          stars0: 1,
          stars1: 1,
          cont: "目前在免费远程控制工具里怕是最好的了……画质不错，速度也不赖。",
        },
        {
          pic: require("@/assets/comment/icon_user15.png"),
          name: "胖虎",
          stars: 4,
          stars0: 1,
          stars1: 0,
          cont: "终于推出了按月付费，太良心了，临时居家办公，按月来买实在太舒服，希望能越做越好。",
        },
        {
          pic: require("@/assets/comment/icon_user19.png"),
          name: "土拨鼠",
          stars: 3,
          stars0: 2,
          stars1: 0,
          cont: "爱死这个软件了，主要是政务外网也能远程控制，其他软件政务外网全废了。",
        },
        {
          pic: require("@/assets/comment/icon_user4.png"),
          name: "心微凉",
          stars: 4,
          stars0: 0,
          stars1: 1,
          cont: "从未用过如此流畅的远程控制软件，一点就连接，这儿有无数个卧槽！今年用其他远程连接工具真是被折磨死了，感谢开发团队。",
        },
        {
          pic: require("@/assets/comment/icon_user8.png"),
          name: "西风",
          stars: 4,
          stars0: 0,
          stars1: 1,
          cont: "自从使用了4.1.1新版todesk后感觉非常好，而且免费不限速，已经完全支撑我的远控需求，赞！",
        },
        {
          pic: require("@/assets/comment/icon_user12.png"),
          name: "渐渐简单",
          stars: 4,
          stars0: 0,
          stars1: 1,
          cont: "真心好用，在家操作办公电脑很流畅，比以前用的其他远程控制软件舒服多了，速度很快呢！",
        },
        {
          pic: require("@/assets/comment/icon_user16.png"),
          name: "慎独",
          stars: 4,
          stars0: 1,
          stars1: 0,
          cont: "这是我用过很多远程控制桌面速度最快的一款了，没有之一，还可以切换屏幕，方便极了。",
        },
        {
          pic: require("@/assets/comment/icon_user20.png"),
          name: "无问西东",
          stars: 4,
          stars0: 1,
          stars1: 0,
          cont: "同样在 1M 的上传速度（受控机）下，我用 ToDesk 操作延迟真的很低，用了两个月，一直很稳定。",
        },
      ],
      configs: {},
    };
  },
  beforeCreate() {
    document.body.style.overflow = "visible";
  },

  methods: {
    swippertab() {
      const that = this;
      let swiper = new Swiper(".swiper-container", {
        // effect: 'fade',
        modules: [Autoplay],
        speed: 300,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          slideChange: function () {
            that.currentIndex = swiper.activeIndex;
          },
        },
      });
      this.tabsSwiper = swiper;
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    check(index) {
      this.tabsSwiper.slideTo(index);
      this.currentIndex = index;
    },
    on(index) {
      this.currentIndex = index;
    },
    open_mask() {
      this.active = !this.active;
    },
    getViewport() {
      // console.log(document.compatMode)
      if (document.compatMode == "BackCompat") {
        return {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
        };
      } else {
        return {
          width: document.documentElement.clientWidth,
          height: document.documentElement.clientHeight,
        };
      }
    },
    getDMOlocation() {
      // 获取元素的相关数据
      this.DOMobj = document.getElementById(`arr${this.a}`);

      if (this.DOMobj && this.DOMobj.offsetHeight) {
        this.cliHeight =
          (this.getViewport().height - this.DOMobj.offsetHeight) / 2;
      } else {
        this.cliHeight = document.documentElement.clientHeight;
      }

      // console.log(this.cliHeight, this.a)
    },
    getElementViewTop(element) {
      // this.v++
      if (element && element.offsetTop) {
        let actualTop = element.offsetTop;
        let current = element.offsetParent;

        while (current !== null) {
          actualTop += current.offsetTop;
          current = current.offsetParent;
        }
        let elementScrollTop;
        // this.v = `${document.documentElement.scrollTop};${document.body.scrollTop}`

        elementScrollTop = Math.max(
          document.documentElement.scrollTop,
          document.body.scrollTop
        );
        // if (document.compatMode == 'BackCompat') {
        //   elementScrollTop = document.body.scrollTop
        // } else {
        //   elementScrollTop = document.documentElement.scrollTop
        // }
        return actualTop - elementScrollTop;
      } else {
        return 4;
      }
    },
    debounce(fn, delay) {
      let timer; // 维护一个 timer
      return function () {
        let _this = this; // 取debounce执行作用域的this
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          fn.apply(_this, args); // 用apply指向调用debounce的对象，相当于_this.fn(args);
        }, delay);
      };
    },
    cl() {
      this.v = 3;
    },
    winScroll() {
      // this.v++
      if (this.DOMobj) {
        const arr = this.getElementViewTop(this.DOMobj);
        const viedos = document.getElementById(`video-${this.a}`);
        this.v = `${arr};${this.cliHeight};${this.DOMobj.offsetHeight}`;

        if (arr / 2 <= this.cliHeight && -arr <= this.DOMobj.offsetHeight / 2) {
          viedos.volume = 0;
          viedos.play();
        } else {
          viedos.pause();
          if (-arr > this.DOMobj.offsetHeight / 2) {
            this.a += 1;
          } else if (-arr < 0) {
            if (this.a === 0) {
              return;
            } else {
              this.a -= 1;
            }
          }
          this.getDMOlocation();
        }
      } else {
        this.a = 4;
        this.getDMOlocation();
      }
    },
    setV(curH, scrH) {
      const viedos = document.getElementById(`video-${this.a}`);
      const arrDom = document.getElementById(`arr${this.a}`);
      if (curH - scrH >= arrDom / 2) {
        viedos.volume = 0;
        viedos.current.play();
      } else {
        viedos.pause();
        this.a += 1;
        if (this.a > 4) this.a -= 1;
        if (this.a <= 1) this.a = 1;
      }
    },
    async getConfig(name) {
      try {
        let res = await this.$serve.getConfig({
          type: 1,
          name: name,
        });
        this.configs = dealConfig(res.data.list, 1);
        this.href = this.configs.android_link;
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
  },
  async created() {
    await this.getConfig("android");
  },
  mounted() {
    this.a = 0;
    this.swippertab();
    this.DOMobj = document.getElementById(`arr${0}`);
    this.timer = setInterval(() => {
      this.getDMOlocation();
      this.winScroll();
    }, 1000);
  },
  // 销毁定时器
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped lang="less">
#sdk {
  overflow-x: hidden;
  /* overflow-y: scroll; */
}
.banner {
  position: relative;
  height: 342px;
  overflow: hidden;
}
.banner .title {
  position: absolute;
  padding: 54px 28px;
  width: 100%;
  box-sizing: border-box;
}
.banner .title h1 {
  margin: 0;
  height: 38px;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1f2329;
  line-height: 38px;
  letter-spacing: 1px;
}
.banner .title h1 span,
.banner .title h2 span {
  color: #0b80fe;
}
.banner .title h2 {
  height: 40px;
  font-size: 32px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #1f2329;
  line-height: 40px;
  letter-spacing: 2px;
  margin: 0;
  margin-top: 11px;
}
.banner .title p {
  margin-top: 10px;
  margin-bottom: 46px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 1px;
  color: #0070f9;
}
.banner .btn {
  display: block;
  height: 48px;
  line-height: 48px;
  background: #0b80fe;
  box-shadow: 0px 5px 10px 0px rgba(59, 129, 205, 0.18);
  border-radius: 6px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
}
.banner .right {
  position: absolute;
  top: -8px;
  right: 0;
  width: 70px;
  height: 90px;
}
.video {
  background: white;
  padding-bottom: 13px;
}
.video ul li {
  text-align: left;
}
.video ul li img {
  margin: 30px 31px 14px 31px;
  width: 36px;
  height: 36px;
}
.video ul li h3 {
  height: 33px;
  font-size: 25px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1f2329;
  line-height: 33px;
  letter-spacing: 1px;
  margin: 0 31px;
}
.video ul li h3 span {
  color: #0b80fe;
}
.video ul li p {
  height: 46px;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #656b74;
  line-height: 21px;
  margin: 15px 31px 0 31px;
}
.active {
  display: flex;
}
.hidden {
  display: none !important;
}
.circular {
  position: absolute;
  bottom: 0;
  display: flex;
}
.circular span {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #ffffff;
  opacity: 0.4;
  margin-right: 8px;
}
.circular span.active {
  width: 21px;
  height: 5px;
  border-radius: 3px;
  background: white;
  opacity: 1;
}
.tab_top li {
  display: flex;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 19px;
}
.tab_top li img {
  width: 50px;
  margin-right: 6px;
}
.tab_top li h2 {
  height: 42px;
  font-size: 29px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 42px;
  margin: 0;
}
.tab_bottom img {
  width: 375px;
}
.download_btn {
  background: white;
  padding: 30px 44px 36px 44px;
  text-align: center;
}
.download_btn.pcss {
  padding-bottom: 41px;
}
.download_btn h2 {
  height: 42px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #272727;
  line-height: 42px;
  margin: 0;
}
.download_btn p {
  height: 21px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #272727;
  line-height: 21px;
  margin-top: 8px;
  margin-bottom: 30px;
}
.download_btn.pcss p {
  margin-bottom: 35px;
}
.tab_card ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 47px 0;
  background-color: #f4f8f9;
}
.tab_card ul li {
  width: 50%;
  text-align: center;
}
.tab_card ul li img {
  width: 88px;
  height: 71px;
}
.tab_card ul li p {
  height: 26px;
  font-size: 19px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #272727;
  line-height: 26px;
  margin-top: 23px;
  margin-bottom: 13px;
}
.tab_card ul li span {
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #272727;
  line-height: 18px;
}
.tab_card ul li:nth-child(-n + 2) {
  margin-bottom: 65px;
}
.download_btn a {
  border: none;
  background: transparent;
  display: inline-block;
}

.download_btn a img {
  width: 210px;
}
.open {
  height: auto !important;
}
.open .introduce_mask {
  display: none;
}
.introduce {
  padding: 29px 19px;
  height: 480px;
  overflow: hidden;
  position: relative;
  background: #f4f8f9;
  margin-bottom: 28px;
}
.introduce_mask {
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), #f4f8f9);
  position: absolute;
  top: 0;
  left: 0;
}
.introduce button {
  width: 98px;
  height: 30px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(184, 187, 193, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0070f9;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
}
.introduce button img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.introduce .item {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 0.17);
  margin-bottom: 13px;
  padding: 24px;
}
.introduce .item-content {
  display: flex;
  align-items: center;
}
.introduce .item-content > img {
  margin-right: 13px;
  width: 42px;
}
.introduce .item-content p {
  height: 15px;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #272727;
  line-height: 22px;
  margin: 0;
  margin-bottom: 14px;
}
.introduce .item-content > div img {
  width: 15px;
  height: 15px;
}
.introduce .item > p {
  width: 286px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5e5e;
  line-height: 25px;
  margin-top: 15px;
  margin-bottom: 0;
}
.introduce .item .io {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.introduce .weibo {
  margin-left: 100px;
}
.consulting {
  padding: 28px 29px;
  background: white;
}
.consulting h2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #272727;
  line-height: 22px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 10px;
  margin: 11px 0;
}
.consulting h5 {
  height: 42px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #272727;
  line-height: 21px;
  margin: 0;
}
.consulting > a {
  width: 47px;
  height: 25px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0070f9;
  line-height: 25px;
}
.consulting ul li p {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(39, 39, 39, 0.5);
  line-height: 19px;
  margin-top: 6px;
}
.consulting ul li a {
  display: block;
  width: 78px;
  height: 31px;
  line-height: 31px;
  background: rgba(1, 110, 253, 0.05);
  border-radius: 16px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #016efd;
  text-align: center;
  float: left;
  margin-right: 13px;
}
.consulting ul li {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
  padding-bottom: 40px;
  margin-bottom: 17px;
}
.seo_link {
  padding: 0 28px 32px 28px;
  background: #fff;
}
.link-sp {
  font-size: 12px;
  color: #999;
  font-weight: normal;
}
.seo_link h2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #272727;
  line-height: 22px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 10px;
  margin-top: 0;
  margin-bottom: 11px;
  padding-top: 10px;
}
.seo_link ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.seo_link ul::after {
  content: "";
  display: block;
  width: 86px;
  visibility: hidden;
}
.seo_link ul li {
  width: 86px;
}
.seo_link ul li a {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #797979;
  line-height: 28px;
}
.video-css {
  width: 100%;
  height: 274px;
}
.solo_bnr {
  position: relative;
  .pic {
    width: 100%;
    height: auto;
    display: block;
  }
  .info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 268px;
    padding-top: 60px;
    box-sizing: border-box;
    .main_title {
      text-align: center;
      font-family: "PingFang SC";
      font-weight: 600;
      font-size: 34px;
      line-height: 48px;
      .t1 {
        color: #0b80fe;
      }
      .t2 {
        color: #222429;
      }
    }
    .desc {
      text-align: center;
      margin-top: 7px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #585f69;
    }
    .link {
      display: block;
      margin: auto;
      background: #0b80fe;
      box-shadow: 0px 5px 10px rgba(59, 129, 205, 0.184823);
      border-radius: 6px;
      width: 327px;
      height: 54px;
      line-height: 54px;
      margin-top: 28px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      text-align: center;
      color: #ffffff;
      &:active {
        background: rgba(11, 128, 254, 0.9);
      }
    }
  }
}
.nversion {
  position: relative;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  overflow: hidden;
  background-image: url(~@/assets/solo/nv_bgi.png);
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
  .nv_bgi_left {
    position: absolute;
    left: 0;
    top: -60px;
    width: 110px;
    height: auto;
    z-index: -1;
  }
  .nv_bgi_right {
    position: absolute;
    right: 0;
    bottom: 158px;
    width: 130px;
    height: auto;
    z-index: -1;
  }
  .left {
    .title {
      position: relative;
      z-index: 1;
      width: fit-content;
      margin: auto;
    }
    .main_title {
      color: #397ef6;
      font-family: "PingFang SC";
      font-weight: 600;
      font-size: 24px;
      line-height: 28px;
      text-align: center;
    }
    .end_title {
      font-family: "PingFang SC";
      font-weight: 600;
      font-size: 40px;
      line-height: 56px;
      color: #c2e9ff;
      opacity: 0.4;
      position: absolute;
      left: -55px;
      top: -25px;
      z-index: -1;
    }
    .title2 {
      color: #000;
      font-family: "PingFang SC";
      font-weight: 600;
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 16px;
      text-align: center;
    }
    .desc_item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 14px;
      margin-left: 27px;
      margin-right: 27px;
      &:last-of-type {
        margin-bottom: 0;
      }
      .desc_item_icon {
        width: 19px;
        height: auto;
        margin-top: 4px;
      }
      .desc_info {
        margin-left: 12px;
        .desc_name {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
        .desc_cont {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #656b74;
          margin-top: 4px;
        }
      }
    }
  }
  .nvvideo_bx {
    text-align: center;
    margin-bottom: 24px;
    video {
      width: 327px;
      object-fit: fill;
      border-radius: 10px;
    }
  }
}
</style>
